/* 教学成效 */
export default [
  {
    path: '/teach',
    name: 'teach',
    redirect: '/teach/home',
    component: ()=> import('@/views/teach-effect/layout'),
    children:[{
      //首页
      path: '/teach/home',
      name: 'teachHome',
      component: ()=> import('@/views/teach-effect/index'),
    },{
      //课程
      path: '/teach/jxeffect',
      name: 'teachJxeffect',
      component: ()=> import('@/views/teach-effect/jxeffect/index'),
    },{
      //班级
      path: '/teach/classeffect',
      name: 'teachClasseffect',
      component: ()=> import('@/views/teach-effect/classeffect/index'),
    },{
      //思政-教学成效
      path: '/teach/classeffectSZ',
      name: 'teachClasseffectSZ',
      component: ()=> import('@/views/teach-effect/classeffect/indexSZ'),
    },{
      //班级教学明细表
      path: '/teach/detail',
      name: 'teachDetail',
      component: ()=> import('@/views/teach-effect/classeffect/teachDetail'),
    },{
      //过程性评价详情表
      path: '/teach/moreEvaluation',
      name: 'moreEvaluation',
      component: ()=> import('@/views/teach-effect/classeffect/moreEvaluation'),
    },{
      //更多学生学习进度
      path: '/teach/moreStuLearning',
      name: 'moreStuLearning',
      component: ()=> import('@/views/teach-effect/classeffect/moreStuLearning'),
    }
    ]
  }
] 
  


// WEBPACK FOOTER //
// ./src/router/teach-Effect.js